import { render, staticRenderFns } from "./ChooseDialog.vue?vue&type=template&id=2a9a5f14&scoped=true"
import script from "./ChooseDialog.vue?vue&type=script&lang=ts"
export * from "./ChooseDialog.vue?vue&type=script&lang=ts"
import style0 from "./ChooseDialog.vue?vue&type=style&index=0&id=2a9a5f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a5f14",
  null
  
)

export default component.exports